import { Enums } from "@/helpers/enums";
import { Ajax, MethodType } from "@/helpers/web";
import { appData, C, J } from "@/helpers/global";

export const PackageService = {
    List(callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.PACKAGE, null, wait).then((data) => {
            data.sort((a, b) => a.order - b.order);
            callback(data);
        });
    },
    ById(id, callback, wait) {
        Ajax.Api(MethodType.Get, Enums.SERVICE.PACKAGE + "/" + id, null, wait).then((data) => {
            callback(data);
        });
    },
}; 